export default "__VITE_ASSET__bd50ef95__"